import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56225efc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stake-withdraw__header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "stake-withdraw__title" }, "Withdraw assets", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "stake-withdraw__description" }, " Your funds will be transfered instantly after transaction go through. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "stake-withdraw__label" }, "Amount to withdraw", -1))
const _hoisted_5 = { class: "stake-withdraw__block" }
const _hoisted_6 = { class: "stake-withdraw__block-item" }
const _hoisted_7 = { class: "stake-withdraw__fee" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "stake-withdraw__fee-title" }, "Network fee:", -1))
const _hoisted_9 = { class: "stake-withdraw__fee-fiat" }
const _hoisted_10 = { class: "stake-withdraw__fee-amount" }

import WhiteWrapper from "@/components/white-wrapper/index.vue";
import ButtonsBlock from "@/components/buttons-block/index.vue";
import BaseButton from "@/components/base-button/index.vue";
import BackButton from "@/components/back-button/index.vue";
import stakeConfirmAmount from "../stake-confirm/components/stake-confirm-amount.vue";
import StakeWithdrawProcess from "./components/stake-withdraw-process.vue";
import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  accounts,
  apiPromise,
  nativeToken,
  selectedNetwork,
  signer,
} from "@/stores";
import { GasFeeInfo } from "@/types/transaction";
import { Account } from "@/types/account";
import { useGetNativeBalances } from "@/libs/balances";
import { useGetNativePrice } from "@/libs/prices";
import { loadStakerState } from "@/utils/staking";
import BigNumber from "bignumber.js";
import { fromBase } from "@/utils/units";
import { getGasFeeInfo } from "@/utils/fee";
import { withdrawExtrinsic } from "@/utils/extrinsic";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const fee = ref<GasFeeInfo>();
const fromAccount = ref<Account>();
const withdrawableBalance = ref<BigNumber>(new BigNumber(0));
const isSend = ref<boolean>(false);
const isSendDone = ref<boolean>(false);
const isError = ref<boolean>(false);

onMounted(() => {
  if (!route.query.address) {
    router.push({ name: "stake" });
    return;
  }
  const found = accounts.value.find(
    (item) => item.address === route.query.address
  );
  if (found) {
    fromAccount.value = found;
  } else {
    router.push({ name: "stake" });
  }
  updateStakedAmount();
  useGetNativeBalances();
  useGetNativePrice();
});

const updateStakedAmount = async () => {
  if (!fromAccount.value) {
    return;
  }

  const api = await apiPromise.value;
  const stakerState = await loadStakerState(api, fromAccount.value.address);

  if (!stakerState?.stakingLedger) {
    return;
  }

  withdrawableBalance.value = new BigNumber(
    fromBase(stakerState.redeemable.toString(), nativeToken.value.decimals)
  );
};

watch(selectedNetwork, () => {
  updateStakedAmount();
  useGetNativeBalances();
  useGetNativePrice();
});

watch(accounts, () => {
  router.push({
    name: "stake",
  });
});

watch(
  [withdrawableBalance],
  async () => {
    if (!withdrawableBalance.value || !fromAccount.value?.address) {
      return;
    }

    const api = await apiPromise.value;

    const tx = await withdrawExtrinsic(api);

    fee.value = await getGasFeeInfo(tx, fromAccount.value?.address || "");
  },
  { deep: true }
);

const nextAction = async () => {
  if (!fromAccount.value) {
    return;
  }
  isSend.value = true;

  const api = await apiPromise.value;

  const tx = await withdrawExtrinsic(api);

  const unsubscribe = await tx.signAndSend(
    fromAccount.value.address,
    {
      signer: signer.value,
      nonce: -1,
    },
    async (result) => {
      if (!result || !result.status) {
        return;
      }

      if (result.status.isFinalized || result.status.isInBlock) {
        result.events
          .filter(({ event: { section } }) => section === "system")
          .forEach(({ event: { method } }): void => {
            if (method === "ExtrinsicFailed") {
              // Handle error
              isError.value = true;
            } else if (method === "ExtrinsicSuccess") {
              // Handle succes
              isSendDone.value = true;
            }
          });
      } else if (result.isError) {
        // Handle error
        isError.value = true;
      }

      if (result.isCompleted) {
        unsubscribe();
      }
    }
  );
};

const back = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (!isSend.value)
    ? (_openBlock(), _createBlock(WhiteWrapper, {
        key: 0,
        class: "stake-withdraw__wrap"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(BackButton, { action: back }),
            _hoisted_2
          ]),
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(stakeConfirmAmount, {
                token: _unref(nativeToken),
                amount: withdrawableBalance.value.toNumber()
              }, null, 8, ["token", "amount"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$filters.currencyFormat(fee.value?.fiatValue || 0, fee.value?.fiatSymbol || "USD")), 1),
            _createElementVNode("p", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(fee.value?.nativeValue || 0)) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(_unref(nativeToken).symbol.toLocaleUpperCase()), 1)
            ])
          ]),
          _createVNode(ButtonsBlock, null, {
            default: _withCtx(() => [
              _createVNode(BaseButton, {
                disabled: withdrawableBalance.value.lte(0),
                title: "Continue",
                action: nextAction,
                send: true
              }, null, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(WhiteWrapper, {
        key: 1,
        class: "stake-withdraw__wrap"
      }, {
        default: _withCtx(() => [
          _createVNode(StakeWithdrawProcess, {
            "is-done": isSendDone.value,
            "is-error": isError.value
          }, null, 8, ["is-done", "is-error"])
        ]),
        _: 1
      }))
}
}

})